import React, { ReactNode } from 'react';
import { Grid } from '@material-ui/core';
import { Colors, Paper, Text } from 'library';
import DoubleCheck from 'assets/icons/double_check.svg';
import Heart from 'assets/icons/heart-small-navy.svg';
import { IGroup } from 'parent-portal/group/models';
import GroupAvatar from 'parent-portal/group/GroupRow/components/GroupAvatar';
import GroupInfo from 'parent-portal/group/GroupRow/components/GroupInfo';

const CarouselCard = ({ group }: { group: IGroup }) => {
    function getIconRow(icon: ReactNode, text: string) {
        return (
            <Grid
                container
                item
                direction="row"
                style={{
                    backgroundColor: Colors.mediumGreen,
                    borderRadius: 15,
                    margin: 5,
                }}
            >
                <Grid
                    item
                    justify="center"
                    alignContent="center"
                    style={{
                        borderRadius: '50%',
                        backgroundColor: Colors.white,
                        height: 25,
                        width: 25,
                        paddingLeft: 8,
                        paddingTop: 2,
                        margin: 10,
                    }}
                >
                    {icon}
                </Grid>

                <Text variant="deprecatedCaption" bold textStyle={{ alignSelf: 'center' }}>
                    {text}
                </Text>
            </Grid>
        );
    }
    function getHireText(hired: any) {
        let text = hired;
        if (hired === 1) {
            text += ` hire made`;
        } else if (hired > 1) {
            text += ` hires made`;
        } else {
            text = `0 hires made`;
        }
        return text;
    }
    function getJobText(job: any) {
        let text = job;
        if (job === 1) {
            text += ` job posted`;
        } else if (job > 1) {
            text += ` jobs posted`;
        } else {
            text = `0 jobs posted`;
        }
        return text;
    }

    return (
        <Paper
            padding={20}
            style={{
                width: 300,

                display: 'flex',
                flexDirection: 'row',
                overflow: 'hidden',
                margin: '0 10px',
            }}
        >
            <Grid item container style={{ padding: 5 }}>
                <Grid xs={12} item container>
                    <GroupAvatar group={group} />
                </Grid>
                <Grid xs={10} container item direction="column">
                    <GroupInfo group={group} />
                </Grid>
                {getIconRow(<DoubleCheck />, getJobText(group.number_jobs_posted))}
                {getIconRow(<Heart />, getHireText(group.number_hires))}
            </Grid>
        </Paper>
    );
};
export default CarouselCard;
